// Receptenoverzicht: filteren op categorie en op apparaat, zonder de pagina te herladen.

class RecipeList extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-recipe-item]')];
    this.buttons = [...this.querySelectorAll('[data-filter]')];
    this.status = this.querySelector('[data-status]');
    this.empty = this.querySelector('[data-empty]');
    this.results = this.querySelector('[data-results]');
    this.state = { category: 'all', device: 'all' };
    try {
      this.counts = JSON.parse(this.querySelector('[data-counts]')?.textContent || '[]');
    } catch {
      this.counts = [];
    }
    this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button)));
  }

  // Een filter tegelijk: een apparaat kiezen zet de categorie terug op alles, en andersom.
  select(button) {
    const { filter, value } = button.dataset;
    if (filter === 'device') {
      this.state.device = this.state.device === value ? 'all' : value;
      this.state.category = 'all';
    } else {
      this.state.category = value;
      this.state.device = 'all';
    }
    this.apply();
    if (filter === 'device' || !button.hasAttribute('aria-pressed')) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.results?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  }

  apply() {
    this.buttons.forEach((button) => {
      if (!button.hasAttribute('aria-pressed')) return;
      const { filter, value } = button.dataset;
      let pressed = this.state[filter] === value;
      if (filter === 'category' && this.state.device !== 'all') pressed = false;
      button.setAttribute('aria-pressed', String(pressed));
    });

    let visible = 0;
    this.items.forEach((item) => {
      const { category, device } = this.state;
      const show =
        (category === 'all' || item.dataset.category === category) &&
        (device === 'all' || item.dataset.device === device);
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (this.empty) this.empty.hidden = visible > 0;
    if (this.status) this.status.textContent = this.counts[visible] || '';
  }
}

customElements.define('recipe-list', RecipeList);
